import { Camera, BarChart3, Target, DollarSign } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

export default function CreatePostBox({ onOpenCreate }) {
  const { user } = useAuth();
  if (!user) return null;

  const actions = [
    { icon: Camera, label: 'Photo/Video', color: 'text-emerald-500' },
    { icon: BarChart3, label: 'Impact Report', color: 'text-blue-500' },
    { icon: Target, label: 'Milestone', color: 'text-amber-500' },
    { icon: DollarSign, label: 'Fundraiser', color: 'text-[#7C3AED]' },
  ];

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-4 mb-4" data-testid="create-post-box">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-gradient-to-r from-[#7C3AED] to-[#2563EB] flex items-center justify-center text-white text-sm font-bold shrink-0">{user.initials}</div>
        <button onClick={onOpenCreate} className="flex-1 h-10 px-4 rounded-lg bg-slate-100 text-left text-sm text-slate-400 hover:bg-slate-200 transition-colors" data-testid="create-post-input">
          Share an impact update...
        </button>
      </div>
      <div className="flex items-center justify-between mt-3 pt-3 border-t border-slate-100">
        {actions.map(a => (
          <button key={a.label} onClick={onOpenCreate} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium text-slate-500 hover:bg-slate-50 transition-colors" data-testid={`create-${a.label.toLowerCase().replace(/\s+/g, '-')}`}>
            <a.icon className={`w-4 h-4 ${a.color}`} />
            <span className="hidden sm:inline">{a.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
